// extracted by mini-css-extract-plugin
export var container = "recipe-modal-module--container--0ac44";
export var loader = "recipe-modal-module--loader--49e18";
export var modal = "recipe-modal-module--modal--cf123";
export var notes = "recipe-modal-module--notes--668c2";